import { EEtazhiBlackFridayActionTypes } from 'shared/actions/etazhiBlackFriday';

import type { IAppState, TActions } from 'shared/common/state';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export const etazhiBlackFridayReducer = (state: IAppState, action: TActions): IAppState => {
  switch (action.type) {
    case EEtazhiBlackFridayActionTypes.SetPromoOffersData: {
      return {
        ...state,
        etazhiBlackFriday: {
          pricesData: state.etazhiBlackFriday?.pricesData ?? null,
          promoOffersData: action.payload,
          isEnabledByRegion: state.etazhiBlackFriday?.isEnabledByRegion ?? false,
        },
      };
    }

    case EEtazhiBlackFridayActionTypes.SetPricesData: {
      return {
        ...state,
        etazhiBlackFriday: {
          pricesData: action.payload,
          promoOffersData: state.etazhiBlackFriday?.promoOffersData ?? null,
          isEnabledByRegion: state.etazhiBlackFriday?.isEnabledByRegion ?? false,
        },
      };
    }

    case EEtazhiBlackFridayActionTypes.SetShowByRegion: {
      return {
        ...state,
        etazhiBlackFriday: {
          pricesData: state.etazhiBlackFriday?.pricesData ?? null,
          promoOffersData: state.etazhiBlackFriday?.promoOffersData ?? null,
          isEnabledByRegion: action.payload,
        },
      };
    }

    default:
      return state;
  }
};
